module.exports = __webpack_public_path__ + "static/brazil-f7d6ba5f2f9dede97c17d61561884ef3.png";